// Shared constants and helpers for the StackRealtime data layer.

import { orgSessionManager } from "@domains/auth/services/orgSessionManager";

// ── Polling intervals ──────────────────────────────────────────────────────────

export const POLL_INTERVAL_MS = 10_000; // REST fallback when WS disconnected
export const METRICS_POLL_MS = 30_000; // Metrics polling interval

// ── Token helper ──────────────────────────────────────────────────────────────

export const getToken = (): string => orgSessionManager.getToken() ?? "";
